export default __webpack_public_path__ + "static/media/016-brownie.3b18b30f.svg";